/**
 * The game's version, from frontend/package.json (baked in by vite.config.ts).
 * Bump it with every release: `npm version patch|minor --no-git-tag-version`
 * in frontend/ (patch = fixes, minor = new features). The Worker reports the
 * same number at /api/health.
 */
declare const __APP_VERSION__: string;

export const APP_VERSION: string = __APP_VERSION__;
